import { render, staticRenderFns } from "./AnnouncementListContainer.vue?vue&type=template&id=de340ff8&scoped=true"
import script from "./AnnouncementListContainer.vue?vue&type=script&lang=js"
export * from "./AnnouncementListContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementListContainer.vue?vue&type=style&index=0&id=de340ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de340ff8",
  null
  
)

export default component.exports